import React, {useEffect, useState} from 'react';
import SongItem from '../../SongItem/SongItem';
import RemoveContact from '../../RemoveContact/RemoveContact';
import SongItemWrapper  from '../../SongItemWrapper/SongItemWrapper'
import AddContact from '../AddContact/addContact';
import { Container, Row , Col } from 'reactstrap';
import stop from '../images/stop.svg';

const SongsWithContacts = (props) => {
    const [openDeleteContactPoUp, setOpenDeleteContactPoUp] = useState(false);
    const [profile, setProfile] = useState({id: null , cli: null});

    function openDeleteContactPoUpFunc(id, cli){
        setOpenDeleteContactPoUp(true);
        setProfile({id: id , cli: cli});
    }

    return (
        <Container className="songs-with-contacts">
            <Row>
                <Col xs="12" sm="12" md="12">
                    <h3>השירים שמשוייכים לאנשי קשר</h3>
                </Col>
            </Row>
            {props.data?.map((item, i) => (            
                <Row key={i}>
                    <Col xs="12" sm="12" md="12">
                    <div className="songs-with-contacts-item">
                        <SongItemWrapper songId={item.productId} isDefaultSong={item.isDefault} isDownloadMode={false} isPlaylistMode={true} audio={{ id: item.productId, description: item.title, author: item.artists.artistName, image: item.image, funtonPrevUrl: item.funtonPrevUrl }}>
                                <SongItem isDisplayPlayer={true} playerSize={87} isDetailsFromLeft={true} onClickSong={()=> {}} audio={{ id: item.productId, description: item.title, author: item.artists.artistName, image: item.image, funtonPrevUrl: item.funtonPrevUrl }} ></SongItem>
                        </SongItemWrapper>
                        {item.profiles.profile?.map((profile, j) => (       
                            <div key={j} className="contact" >
                                <div className="cli">{profile.cli.callerCli}</div>
                                <button onClick={() => {openDeleteContactPoUpFunc(profile.id, profile.cli.callerCli)}} className="remove-contact-btn" style={{backgroundImage:stop.bg()}}></button>
                            </div>     
                        ))}
                        <AddContact item={item} />            
                    </div>
                    </Col>
                </Row>            
            ))}
        <RemoveContact  show={openDeleteContactPoUp} close={()=> {setOpenDeleteContactPoUp(false)}} data={profile}></RemoveContact>
        </Container>) ;
}


  export default SongsWithContacts;